import React from "react";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import { getColor } from "aible/Tile/Tile";

import styles from "./style.module.css";

export default class TileBody extends React.PureComponent {
  render() {
    const {
      className,
      children,

      isLoading,
      loadingText,
      isError,
      errorText,
      showOnError,
      noMargin,

      color,
      ...retProps
    } = this.props;

    return (
      <div
        className={styles.tileBody + " " + (noMargin ? styles.noMargin : "") + " " + (className ? className : "")}
        {...retProps}
      >
        {!isError || showOnError ? (
          isLoading ? (
            <TileLoading color={color} text={loadingText || "Loading..."} />
          ) : (
            children
          )
        ) : (
          ""
        )}
        {isError ? <TileError forceShow={showOnError} text={errorText || "We encounted an error"} /> : ""}
      </div>
    );
  }
}

class TileError extends React.PureComponent {
  render() {
    const { text, forceShow, className, ...retProps } = this.props;
    if (typeof text !== "string") {
      return text;
    }
    return (
      <div
        className={
          styles.tileErrorText + " " + (forceShow ? styles.forceShow : "") + " " + (className ? className : "")
        }
        {...retProps}
      >
        {text}
      </div>
    );
  }
}

class TileLoading extends React.PureComponent {
  render() {
    const { text, color } = this.props;
    return (
      <React.Fragment>
        {typeof text === "string" ? <div className={styles.tileLoadingText}>{text}</div> : text}
        <div className={styles.tileLoadingIndicator}>
          <LoadingIndicator color={getColor(color)} style={{ margin: "0px auto" }} />
        </div>
      </React.Fragment>
    );
  }
}
